import Base from '../base.js'

export default class Contacts extends Base {
  constructor () {
    super('contact/')
  }
}
